<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Widget Tab Select"
  >
    <ul v-sortable="{ method: 'orderTabs' }">
      <li
        v-for="(tab, tabKey) in tabs"
        :key="tabKey"
      >
        <a href="#" @click.prevent="setTab(tabKey)">{{ tab.title }}</a>
        <ul v-if="subTabs && subTabs[tabKey]">
          <li
            v-for="(subTab, subTabKey) in subTabs[tabKey]"
            :key="subTabKey"
          >
            <a href="#" @click.prevent="setTab(tabKey, subTabKey)">{{ subTabs[tabKey][subTabKey].title }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </b-modal>
</template>

<script>
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'


export default {
  data () {
    return {
      tabs: null,
      subTabs: null,
      widgetKey: null
    }
  },
  methods: {
    open () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    setTab (tabKey, subTabKey) {
      db.widgets.changeTab(this.widgetKey, tabKey, subTabKey, () => {
        this.makeToast('success')
        this.close()
      })
    },
    makeToast(variant = null) {
      this.$bvToast.toast('Tab have been changed for selected widget.', {
        title: 'Success!',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 2500,
      })
    }
  },
  created () {
    eventBus.$on('setTabForWidget', (widgetKey) => {
      this.widgetKey = widgetKey
      this.open()
    })

    db.tabs.read((tabs) => {
      this.tabs = tabs
    })

    db.tabs.readSubTabs((subTabs) => {
      const tbs = _.cloneDeep(this.tabs)
      this.tabs = null
      this.subTabs = subTabs
      this.$nextTick(() => {
        this.tabs = tbs
      })
    })
  }
}
</script>
